import React from 'react'
import classes from './Social.module.css';
import facebook from './img/icons/facebook.png';
import instagram from './img/icons/instagram.png';
import twitter from './img/icons/twitter.png';
import dribble from './img/icons/dribble.png';
import MetaTags from 'react-meta-tags';


function Social() {
  return (
    <div className={classes.social}>
    <MetaTags>
      <title>Social</title>
      <meta name="description" content="Some description." />
      <meta property="og:title" content="MyApp" />
      <meta property="og:image" content="path/to/image.jpg" />
    </MetaTags>
      <li><a href="https://www.facebook.com/adarsh.km.100" target="_blank"><img src={facebook} className={classes.media} alt="" /></a></li>
      <li><a href="https://www.instagram.com/adarshkm24/?hl=en" target="_blank"><img src={instagram} className={classes.media}  alt="" /></a></li>
      <li><a href="https://twitter.com/Adarshk58750173" target="_blank"><img src={twitter} className={classes.media}  alt="" /></a></li>
      <li><a href="https://dribbble.com/gabrialgracialmarques" target="_blank"><img src={dribble} className={classes.media}  alt="" /></a></li>
    </div>
  )
}

export default Social

